import { Component } from '@angular/core';
import { NotificationService } from '../../../../service';

@Component({
  standalone: false,
  selector: 'admin-trusts',
  templateUrl: './trusts.component.html'
})
export class TrustsComponent {
  constructor(private notificationService: NotificationService) {}

  public notify(msg: [string, string]): void {
    this.notificationService.success(msg[0], msg[1]);
  }
}
